export const environment = {
  production: true,
  serviceUrl: "https://develop.api.emaaya.digimaaya.com/api/",
  MAIN_ETHEREUM_NETWORK: "https://mainnet.infura.io/HXqhYu4Qf8kqVi0GcVBj",
  ROPSTEN_ETHEREUM_NETWORK: "https://ropsten.infura.io/HXqhYu4Qf8kqVi0GcVBj",
  RINKEBY_ETHEREUM_NETWORK: "https://mainnet.infura.io/HXqhYu4Qf8kqVi0GcVBj",
  KOVAN_ETHEREUM_NETWORK: "https://kovan.infura.io/HXqhYu4Qf8kqVi0GcVBj",
  INFURANET_ETHEREUM_NETWORK:
    "https://infuranet.infura.io/HXqhYu4Qf8kqVi0GcVBj",
  IPFS_GATEWAY: "https://ipfs.infura.io",
  IPFS_RPC: "https://ipfs.infura.io:5001",
  ETH_SCAN_ADDR: "https://rinkeby.etherscan.io/addr/",
  ETH_SCAN_TX: "https://rinkeby.etherscan.io/tx/",
  CHAINID: 4,
  v: "0x04",
  r: "0x00",
  s: "0x00",
  PIPTLE_CONTRACT_ADDRESS: "41291860370a7732b4f3d11b3ed34dcbb05f47112f",
};
